export default "__VITE_ASSET__0cRXpxi9__"